import React from 'react'

export const ErrorToast = ({message}) => {
    return (
        <div className="alert alert-danger alert-icon alert-dismissible fade show" role="alert">
            <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">×</span>
            </button>
            {message}
        </div>
    )
}
